import { FONT_TYPE } from '../../constants';
import * as RTLUnited from '../../fonts/RTLUnited/RTLUnited.descriptors';

export const fonts = {
  [FONT_TYPE.MAIN]: RTLUnited,
};
